import { navigateTo } from 'gatsby-link';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import logoFallback from '../assets/logo.png';
import logo from '../assets/logo.svg';
import { scrollToElement } from '../utils';
import Drawer from './Drawer';
import styles from './Header.module.css';
import Toolbar from './Toolbar';


class Header extends Component {
  constructor(props) {
    super(props);

    const isIndex = this.props.pathname === '/';
    let activeEl = null;
    if (isIndex) {
      activeEl = 'home';
    } else if (this.props.pathname === '/verwaltung') {
      activeEl = 'verwaltung';
    }

    this.state = {
      isIndex,
      activeEl,
      expanded: true,
    };
  }

  componentDidMount() {
    const { routes, categories } = this.props;
    this.elements = [...routes, ...categories].reduce((red, category) => {
      const el = document.querySelector(category.hash);
      if (!el) return red;
      return [...red, { el, ...category }];
    }, []);
    setTimeout(() => window.scrollTo(0, 0), 0);
    window.addEventListener('scroll', this.onNavHide);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('scroll', this.onNavHide);
  }

  onNavHide = scr => {
    const { pageY = (window.scrollY = window.pageYOffset) } = scr;
    const { expanded } = this.state;
    const { offset } = this.props;
    if (expanded && pageY > offset) {
      this.setState({ expanded: false });
    } else if (!expanded && pageY <= offset) {
      this.setState({ expanded: true });
    }
  };

  renderLinks() {
    const { routes, categories, pathname } = this.props;
    const { activeEl } = this.state;

    return [...routes, ...categories].reduce((red, { hash, name, hideNav, path }, i) => {
      if (hideNav) return red;
      const el = hash.replace('#', '');
      const sameRoute = pathname === '/' || el === 'kontakt';
      const offset = typeof window !== 'undefined' && window.innerWidth <= 768 ? 0 : -100;
      const active = el === activeEl;
      const onClick = () => {
        if (pathname === 'verwaltung' && path === 'verwaltung' || pathname === 'verkauf' && path === 'verkauf') {
          return
        }
        if (!sameRoute) {
          navigateTo(`/${hash}`)
        }
      };
      const onSetActive = el => this.setState({ activeEl: el });
      const onSetInactive = () => (pathname === '/verwaltung' ? this.setState({ activeEl: 'verwaltung' }) : undefined);
      return [...red, { name, el, offset, onSetActive, onSetInactive, active, onClick }];
    }, []);
  }

  render() {
    const { company } = this.props;
    const { expanded, isIndex } = this.state;
    const links = this.renderLinks();

    const logoImg = (
      <img
        src={logo}
        onError={e => (e.target.src !== logoFallback ? (e.target.src = logoFallback) : undefined)}
        onClick={() => (isIndex ? scrollToElement('#home') : navigateTo('/'))}
      />
    );
    return (
      <div className={styles.header}>
        <Toolbar className={styles.toolbar} logo={logoImg} links={links} expanded={this.state.expanded} company={company} />
        <Drawer className={styles.drawer} logo={logoImg} links={links} company={company} scrolled={!expanded || !isIndex} />
      </div>
    );
  }
}

Header.propTypes = {
  company: PropTypes.shape({
    addressFields: PropTypes.arrayOf(PropTypes.string),
    address: PropTypes.string,
    name: PropTypes.string,
    ceo: PropTypes.string,
    mobile: PropTypes.string,
    mail: PropTypes.string,
    phone: PropTypes.string,
    coordinates: PropTypes.shape({ lat: PropTypes.number.isRequired, lon: PropTypes.number.isRequired }),
  }).isRequired,
  offset: PropTypes.number.isRequired,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hideNav: PropTypes.bool,
    })
  ).isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      hash: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  pathname: PropTypes.string.isRequired,
  hash: PropTypes.string.isRequired,
};

Header.defaultProps = {
  offset: 16,
  hash: '',
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js